/** @format */

import {styled, Theme} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'Dropdown';

const classes = {
  scrollable: `${PREFIX}-scrollable`,
  divider: `${PREFIX}-divider`,
  removeButtonBlock: `${PREFIX}-removeButtonBlock`,
  removeButtonLabel: `${PREFIX}-removeButtonLabel`,
  removeModalButtons: `${PREFIX}-removeModalButtons`,
  removeModalMessage: `${PREFIX}-removeModalMessage`,
};

export const getScrollableStyle = (theme: Theme) => ({
  '&::-webkit-scrollbar': {height: '9px', width: '9px'},
  '&::-webkit-scrollbar-track': {
    background: theme.palette.figma_gray_light_4?.main,
    borderRadius: '0 8px 8px 0',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '5px',
    background: 'rgba(0, 0, 0, 0.55)',
  },
  '&::-webkit-scrollbar-button': {display: 'none'},
});

interface RootProps {
  lockScroll: boolean;
}

const Root = styled(Box, {
  shouldForwardProp: prop => prop !== 'lockScroll',
})<RootProps>(({theme, lockScroll}) => ({
  width: '300px',
  borderRadius: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.figma_gray_light_4?.main,
  padding: theme.spacing(2, 0, 1, 0),
  maxHeight: '75vh',

  // ! Если вносите сюда правки, проверьте, чтобы sub-menu рендерилось нормально

  [`& .${classes.scrollable}`]: {
    ...getScrollableStyle(theme),
    overflowY: lockScroll ? 'hidden' : 'auto',
  },

  [`& .${classes.divider}`]: {
    width: '100%',
    border: '1px solid #e2e3e9',
  },

  [`& .${classes.removeButtonLabel}`]: {
    color: theme.palette.figma_gray_dark_5?.main,
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: '20px',
  },

  [`& .${classes.removeModalButtons}`]: {
    display: 'flex',
    gap: theme.spacing(4),
    width: '100%',
    justifyContent: 'space-between',
    marginTop: theme.spacing(4),
  },

  [`& .${classes.removeModalMessage}`]: {
    textAlign: 'center',
  },
}));

const ButtonsBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexShrink: 0,
  gap: theme.spacing(1),
  padding: theme.spacing(2, 4),
  background: theme.palette.figma_gray_light_4?.main,
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export {Root as DropdownRoot, ButtonsBox, classes as dropdownClasses};
